$(document).ready(function() {
  if ($('.product-images').length) {
    $('.product-images').slick({
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      dots: true,
      fade: true,
      speed: 0
    });
  }
  
  // Cart Click Function

  $('#cart-link').click(e => {
    e.preventDefault();
    $('.cart-drawer').addClass('open');
    $('#cart').addClass('open');
  });
  $('.cart-close').click(() => {
    $('.cart-drawer').removeClass('open');
    $('#cart').removeClass('open');
  });
  // Mobile Menu
  $('.mobile-menu').click(e => {
    e.preventDefault();
    $('.mobile-nav').addClass('nav-open');
    $('.inner-nav').addClass('nav-open');
  });
  $('.menu-close').click(() => {
    $('.mobile-nav').removeClass('nav-open');
    $('.inner-nav').removeClass('nav-open');
  });

  // Remove img from <p> in blog posts
  if ($('.article-content').length) {

    if ($('img').parent('p')) {
      let parent = $('img').parent('.article-content > p');
      for (let i = 0; i < parent.length; i++) {
        let child = parent[i].children[0];
        parent[i].replaceWith(child);
      }


    }
  }


});
